import React from "react";
import "./Footer.css";
const Footer = () => {
  return (
    <div className="footer">
      © 2024 DSAK789. All rights reserved.
    </div>
  );
};

export default Footer;
